import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private http: HttpClient,
        private connectionService: ConnectionService,
        private router: Router) { }

    
    isAuthenticated () {
        if (this.connectionService.isConnected()) {
            return true;
        } else {
            return false;
        }
    }

    authenticate(server: string, password: string) {
        let address = server;

        return this.http.post(address + "/auth-service/login", {password});
    }

    logout () {
        this.connectionService.clear();
        this.router.navigate(["login"]).then(() => {
            window.location.reload();
        });
    }

}
